interface ProgressBarProps {
  total: number;
  current: number;
}

export default function ProgressBar({ total, current }: ProgressBarProps) {
  return (
    <div className="quiz-progress">
      {Array.from({ length: total }).map((_, i) => (
        <div
          key={i}
          className={`progress-dot${i < current ? ' done' : ''}${i === current ? ' current' : ''}`}
        />
      ))}
    </div>
  );
}
